import React, { useState, useEffect } from "react";
import {
  Table,
  TableRow,
  TableBody,
  useTheme,
  Box,
  Typography,
  TableContainer,
  Tooltip,
} from "@mui/material";
import VantageListHead from "../../../../component/ListHead/SignalList";
import {
  Tablecell,
  applySortFilter,
  calculateAndFormatNoAbs,
  getComparator,
} from "../../../../component/Methods";

const AfterOrder = ({ afterOrders, tableHeader }) => {
  const theme = useTheme();
  const [data, setData] = useState([]);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("strategy");

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  useEffect(() => {
    if (afterOrders) {
      const formattedData = Object?.entries(afterOrders)?.map(
        ([strategy, positions]) => ({
          strategy,
          ...positions,
        })
      );
      const filteredUsers = applySortFilter(
        formattedData,
        getComparator(order, orderBy)
      );
      setData(filteredUsers);
    }
  }, [order, orderBy, afterOrders]);

  return (
    <>
      <Box
        sx={{
          border: `100px ${theme.palette.lightGrey.tableHeader}`,
          borderRadius: "4px",
          marginTop: "1px",
          width: "80%",
          marginRight: 1,
        }}
      >
        <Typography sx={{ fontWeight: "bold", fontSize: "20px", mb: 1 }}>
          Calculated Positions After Execution
        </Typography>

        <TableContainer
          style={{
            height: "auto",
            maxHeight: "300px",
            minHeight: "50px"
          }}
        >
          <Table
            size="small"
            stickyHeader
            aria-label="a dense table"
            sx={{
              height: "max-content",
            }}
          >
            <VantageListHead
              order={order}
              orderBy={orderBy}
              headLabel={tableHeader}
              noStatus={true}
              customizeFont={12}
              rowCount={data.length}
              onRequestSort={handleRequestSort}
            />
            <TableBody>
              {data?.map((row, index) => (
                <TableRow
                  key={index}
                  sx={{
                    "&:hover": {
                      background: theme.palette.grey[200],
                      cursor: "pointer",
                    },
                  }}
                >
                  <Tablecell
                    align="left"
                    style={{
                      fontSize: "12px",
                      paddingLeft: "10px",
                      borderLeft: "none",
                      borderRight: "none",
                      color: theme.palette.text.primary,
                      borderColor: theme.palette.divider,
                    }}
                  >
                    {row?.strategy}
                  </Tablecell>
                  <Tooltip
                    title={`Real: ${row?.starting?.real}, Cros: ${row?.starting?.cross}`}
                    arrow
                    PopperProps={{
                      sx: {
                        '& .MuiTooltip-tooltip': {
                          fontSize: '16px',
                          padding: '10px',
                        },
                      },
                    }}
                  >
                    <Tablecell
                      align="right"
                      style={{
                        fontSize: "12px",
                        paddingRight: "10px",
                        borderLeft: "none",
                        borderRight: "none",
                        color: theme.palette.text.primary,
                        borderColor: theme.palette.divider,
                      }}
                    >
                      {calculateAndFormatNoAbs(row?.starting?.net)}
                    </Tablecell>
                  </Tooltip>

                  <Tooltip
                    title={`Real: ${row?.orders?.real}, Cros: ${row?.orders?.cros}`}
                    arrow
                    PopperProps={{
                      sx: {
                        '& .MuiTooltip-tooltip': {
                          fontSize: '16px',
                          padding: '10px',
                        },
                      },
                    }}
                  >
                    <Tablecell
                      align="right"
                      style={{
                        fontSize: "12px",
                        paddingRight: "10px",
                        borderLeft: "none",
                        borderRight: "none",
                        color: theme.palette.text.primary,
                        borderColor: theme.palette.divider,
                      }}
                    >
                      {calculateAndFormatNoAbs(row?.orders?.net)}
                    </Tablecell>
                  </Tooltip>
                  <Tooltip
                    title={`Real: ${row?.ending?.real}, Cros: ${row?.ending?.cros}`}
                    arrow
                    PopperProps={{
                      sx: {
                        '& .MuiTooltip-tooltip': {
                          fontSize: '16px',
                          padding: '10px',
                        },
                      },
                    }}
                  >
                    <Tablecell
                      align="right"
                      style={{
                        fontSize: "12px",
                        paddingRight: "10px",
                        borderLeft: "none",
                        borderRight: "none",
                        color: theme.palette.text.primary,
                        borderColor: theme.palette.divider,
                      }}
                    >
                      {calculateAndFormatNoAbs(row?.ending?.net)}
                    </Tablecell>
                  </Tooltip>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </>
  );
};

export default AfterOrder;
